import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { Filesystem, Directory } from '@capacitor/filesystem';
import { Share } from '@capacitor/share';

@Injectable({
  providedIn: 'root'
})
export class ExcelService {

  // xlsxRef: la instancia de xlsx-js-style que carga el componente llamador de forma lazy
  async exportWorkbook(workbook: any, fileName: string, xlsxRef: any): Promise<void> {
    if (!Capacitor.isNativePlatform()) {
      xlsxRef.writeFile(workbook, fileName);
      return;
    }

    const base64 = xlsxRef.write(workbook, {
      bookType: 'xlsx',
      type: 'base64',
    });

    const result = await Filesystem.writeFile({
      path: fileName,
      data: base64,
      directory: Directory.Cache,
    });

    await Share.share({
      title: fileName,
      text: 'Archivo Excel exportado',
      url: result.uri,
      dialogTitle: 'Compartir Excel',
    });
  }
}